module.exports = ".form-group {\r\n  margin-left: 0;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/identity/new-barcode-form/new-barcode-form.component.css
// module id = ./src/app/identity/new-barcode-form/new-barcode-form.component.css
// module chunks = main